import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=cda01b50&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cda01b50')) {
      api.createRecord('cda01b50', component.options)
    } else {
      api.reload('cda01b50', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=cda01b50&", function () {
      api.rerender('cda01b50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pffHNKBFfOvZ/JS/comp/IncreaseNumber.vue"
export default component.exports